import { Middleware } from 'redux';
import { discountSetActions } from 'redux/modules/DiscountEditor/discountEditorTypes';
import { localStorageManager } from 'services/localStorage';
import { RootState } from '../store';

export const discountEditorToLocalStorage: Middleware<
  Record<string, never>,
  RootState
> = (state) => (next) => (action) => {
  if (action.type === discountSetActions.RESET_DISCOUNT_EDITOR) {
    localStorageManager.clearDiscountEditor();

    return next(action);
  }

  if (action.type.includes('discountEditor')) {
    const result = next(action);

    localStorageManager.setDiscountEditor(state.getState().discountEditor);

    return result;
  }

  return next(action);
};
